var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExternalLinkRtl = function SvgExternalLinkRtl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "external-link-rtl_svg__a",
    width: 100,
    height: 100,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h100v100H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#external-link-rtl_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3A3D3F",
    d: "M18.543 92h63.065C87.337 92 92 87.34 92 81.608v-63.15c0-5.73-4.66-10.391-10.392-10.391H58.015a2.504 2.504 0 0 0 0 5.008h23.593a5.39 5.39 0 0 1 5.384 5.384v63.15a5.39 5.39 0 0 1-5.384 5.383H18.543a5.39 5.39 0 0 1-5.384-5.384v-23.65a2.504 2.504 0 0 0-5.009 0v23.65C8.15 87.338 12.811 92 18.543 92M40.78 8a2.539 2.539 0 1 1 .059 5.078l-23.952.228 45.394 45.387c.99.99.99 2.593 0 3.584-.991.99-2.594.99-3.584 0l-45.39-45.39-.229 23.95a2.54 2.54 0 0 1-2.568 2.51A2.54 2.54 0 0 1 8 40.777l.418-30.065c.002-.317.072-.632.203-.921a2.55 2.55 0 0 1 1.29-1.291c.29-.13.604-.2.922-.203z"
  }))));
};
export default SvgExternalLinkRtl;